import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Choisissez votre plan de départ <br/> Nous gérons tout, <underline>VOUS</underline> vous reposez 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Payer plus tard sur les ventes',
    [BillingMode.Stripe]: "(0)[Payer maintenant];(1-inf)[Payer maintenant (économisez jusqu'à {{discount}})]",
  },
};
